"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _BudgetRepartitionCard = _interopRequireDefault(require("./BudgetRepartitionCard"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var _default = _BudgetRepartitionCard["default"];
exports["default"] = _default;